export default __webpack_public_path__ + "static/media/gallery_00.39f920ea.jpg";